module.exports = __webpack_public_path__ + "img/sms.7f3b653f.svg";